import styled from 'styled-components'

export const ViewContainer = styled.div`
    /* ===== Scrollbar CSS ===== */
    /* Firefox */
    * {
        scrollbar-width: auto;
        scrollbar-color: ${({ theme }) => theme['gray-300']} ${({ theme }) => theme['gray-0']};
    }

    /* Chrome, Edge, and Safari */
    *::-webkit-scrollbar {
        width: 15px;
    }

    *::-webkit-scrollbar-track {
        background: ${({ theme }) => theme['gray-0']};
    }

    *::-webkit-scrollbar-thumb {
        background-color: ${({ theme }) => theme['gray-300']};
        border-radius: 10px;
        border: 3px solid ${({ theme }) => theme['gray-0']};
    }

    position: relative;
    width: 100%;
    height: 100%;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    background-color: ${({ theme }) => theme['gray-0']};
    overflow: auto;

    .titleBar {
        width: 100%;
        height: 40px;
        background: ${({ theme }) => theme['gray-100']};
        font-weight: 700;
        font-size: 15px;
        padding: 0 16px;
        display: flex;
        align-items: center;
    }
    .pagination {
        width: 100%;
        height: 64px;
        display: flex;
        flex-direction: row;
        align-items: center;
        /* justify-content: space-between; */
        padding: 0 16px;
        justify-content: end;
    }

    .tableContainer {
        width: 100%;
        height: calc(100% - 104px);
        padding: 0 16px;
        overflow: auto;

        thead th {
            height: 48px;
            position: sticky;
            top: 0;
            z-index: 1;
        }
    }

    .tableContainerWithGraphic {
        width: 100%;
        height: calc(100% - 392px);
        padding: 0 16px;
        overflow: auto;

        thead th {
            position: sticky;
            top: 0;
            z-index: 1;
        }
    }

    table {
        width: 100%;
        /* height: 100%; */

        thead {
            height: 48px;
        }

        th {
            background: ${({ theme }) => theme['gray-200']};
            text-transform: uppercase;
            font-size: 11px;
        }

        th button {
            padding: 2px 16px 0px;
            height: 32px;
            text-transform: uppercase;
            font-size: 11px;
            border: none;
            font-weight: 600;
            color: ${({ theme }) => theme['gray-900']};
        }
        th button:hover {
            background-color: ${({ theme }) => theme['gray-700']};
            color: ${({ theme }) => theme['gray-0']};
        }
        th button:focus {
            background-color: ${({ theme }) => theme['gray-700']};
            color: ${({ theme }) => theme['gray-0']};
        }
        th button:active {
            background-color: ${({ theme }) => theme['gray-700']};
            color: ${({ theme }) => theme['gray-0']};
        }

        th button i {
            font-size: 10px;
            width: 12px;
            margin-left: 4px;
            height: 16px;
        }

        tr {
            width: 100%;
            max-height: 30px;
        }

        tr:hover {
            cursor: pointer;
            background-color: ${({ theme }) => theme['gray-100']};
        }

        .first-margin {
            border-bottom: 1px solid red;
        }

        .mozilla-margin {
            height: 48px;
            display: none;
            &.limit10 {
                display: block;
            }
        }

        td {
            padding: 8px 16px;
            border-bottom: 1px solid;
            border-color: ${({ theme }) => theme['gray-200']};
            font-size: 12px;
            color: ${({ theme }) => theme['gray-800']};
        }

        .trWithGraph {
            td {
                padding: 0;
                .toGraph {
                    width: 100%;
                    height: 100%;
                    padding: 8px 16px;
                    text-align: left;
                    background: transparent;
                    border: none;
                }
            }
        }

        .ACTIVE {
            color: #129a96;
        }

        .INACTIVE {
            color: ${({ theme }) => theme['red-700']};
        }

        .DEGRADED {
            color: ${({ theme }) => theme['yellow-700']};
        }

        .LOW_DEGRADED {
            color: #a2a94f;
        }

        .HIGH_DEGRADED {
            color: #f89300;
        }

        .LOWLY {
            color: #a2a94f;
        }

        .HIGHLY {
            color: #f89300;
        }

        .UNKNOWN {
            color: ${({ theme }) => theme['gray-700']};
        }

        .Tolerable {
            color: ${({ theme }) => theme['yellow-700']};
        }

        .Unacceptable {
            color: ${({ theme }) => theme['red-700']};
        }

        .Acceptable {
            color: ${({ theme }) => theme['green-700']};
        }

        .Tolerável {
            color: ${({ theme }) => theme['yellow-700']};
        }

        .Inaceitável {
            color: ${({ theme }) => theme['red-700']};
        }

        .Aceitável {
            color: ${({ theme }) => theme['green-700']};
        }

        .barrierStatus {
            text-transform: capitalize;
        }

        .type {
            text-transform: capitalize;
        }
    }

    .tableHeader {
        height: 36px;
    }

    .ScrollbarsCustom {
        .ScrollbarsCustom-Wrapper {
            width: 100%;
            height: calc(100% - 50px);
        }

        .ScrollbarsCustom-TrackY {
            height: calc(100% - 60px) !important;
        }
    }
`

export const NoInfo = styled.div`
    position: absolute;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    padding: 20px;
    margin-top: 70px;
`

export const NoData = styled.div`
    position: absolute;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    padding: 20px;
    margin-top: 70px;
`
